import React, { FC } from 'react'
import { IonHeader } from '@ionic/react'
import { observer } from 'mobx-react'
import './index.scss'

interface IProps {
  isRecommend?: boolean;
  children: any;
  clsName?: string;
  color?: 'pink' | 'yellow' | 'grey';
}

const CardBuyItem: FC<IProps> = ({ isRecommend = false, color = 'yellow', clsName, children }: IProps) => {
  return (
    <IonHeader>
      <div className={`mkt-card-buy-item ${color}${clsName ? ` ${clsName}` : ''}`}>
        {children}
        {isRecommend && <div className='card-buy-item-reco'>{i18n.t('mkt.giftCard.recommend')}</div>}
      </div>
    </IonHeader>
  )
}

export default observer(CardBuyItem)
